/* Cuisine Inspirante — fiche « Pour-Over » (snippet ci-po-buybox, sections ci-po-*).
   - Copie du code promo
   - Choix « produit seul / kit » : au moment de l'ajout au panier, la variante du kit
     correspondant à la couleur choisie remplace celle du produit (le thème gère le reste).
   - Carrousel d'arguments
   - Bouton « Choisir le kit » des sections ci-po-kit */
(function () {
  if (window.__ciPoReady) return;
  window.__ciPoReady = true;

  /* ---------- Code promo ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ci-po-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-ci-po-copy');
    var box = btn.closest('[data-ci-po-promo]');
    var status = box && box.querySelector('[data-ci-po-copy-status]');
    var label = btn.querySelector('[data-ci-po-copy-label]');
    function done(ok) {
      if (label) label.textContent = ok ? 'Copié' : 'Copier';
      if (status) status.textContent = ok ? 'Code ' + code + ' copié : collez-le au moment du paiement.' : 'Copie automatique indisponible : notez le code ' + code + '.';
      setTimeout(function () {
        if (label) label.textContent = 'Copier';
        if (status) status.textContent = '';
      }, 4000);
    }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () { done(true); }, function () { done(false); });
      } else { done(false); }
    } catch (err) { done(false); }
  });

  /* ---------- Kit ---------- */
  function kitRoot(el) {
    return el.closest('.shopify-section') || document;
  }
  function kitState(fs) {
    var pick = fs.querySelector('[data-ci-po-kit-pick]');
    return !!(pick && pick.checked);
  }
  function syncKit(fs) {
    var on = kitState(fs);
    fs.querySelectorAll('.ci-po-kit__opt').forEach(function (l) {
      var input = l.querySelector('input');
      l.classList.toggle('is-sel', !!(input && input.checked));
    });
    var note = fs.querySelector('[data-ci-po-kit-note]');
    if (note) note.hidden = !on;
  }
  document.querySelectorAll('[data-ci-po-kit]').forEach(syncKit);
  document.addEventListener('change', function (e) {
    var fs = e.target.closest('[data-ci-po-kit]');
    if (fs) syncKit(fs);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var root = kitRoot(form);
    var fs = root.querySelector('[data-ci-po-kit]');
    if (!fs || !kitState(fs)) return;
    var map;
    try { map = JSON.parse(fs.querySelector('[data-ci-po-kit-map]').textContent); } catch (err) { return; }
    var inputs = form.querySelectorAll('[name="id"]');
    inputs.forEach(function (input) {
      var orig = input.value;
      var color = map.main[orig];
      var target = (color && map.kit[color]) || null;
      var kitId = target && target.available ? target.id : map.kitFirst;
      if (!kitId) return;
      input.value = String(kitId);
      /* Le thème lit le formulaire pendant cet événement : on rétablit ensuite la variante affichée. */
      setTimeout(function () { input.value = orig; }, 0);
    });
  }, true);

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ci-po-pick-kit]');
    if (!a) return;
    var pick = document.querySelector('[data-ci-po-kit-pick]');
    if (!pick) return;
    e.preventDefault();
    pick.checked = true;
    pick.dispatchEvent(new Event('change', { bubbles: true }));
    var fs = pick.closest('[data-ci-po-kit]');
    (fs || pick).scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* ---------- Carrousel d'arguments ---------- */
  function initArgs(scope) {
    (scope || document).querySelectorAll('[data-ci-po-args]').forEach(initBox);
    (scope || document).querySelectorAll('[data-ci-po-kit]').forEach(syncKit);
  }
  document.addEventListener('shopify:section:load', function (e) { initArgs(e.target); });
  initArgs(document);

  function initBox(box) {
    if (box.__ciPo) return;
    box.__ciPo = true;
    var slides = box.querySelectorAll('[data-ci-po-slide]');
    var dots = box.querySelectorAll('[data-ci-po-dot]');
    if (slides.length < 2) return;
    var i = 0;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== i; });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-on', k === i);
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-ci-po-prev]')) go(i - 1);
      else if (e.target.closest('[data-ci-po-next]')) go(i + 1);
      else {
        var d = e.target.closest('[data-ci-po-dot]');
        if (d) go(parseInt(d.getAttribute('data-ci-po-dot'), 10) || 0);
      }
    });
  }
})();
